import type { Context } from "../models/context";
import type { Data } from "../models/data";

export interface IGeoServiceApiKeys {
    google: string,
    here: string,
    mapbox: string
}

/**
 * Setting 275 carries the keys per brand. Google/HERE fall back to the app-wide keys for brands
 * missing them or with stale cached brand data; Mapbox has no app-wide key.
 */
export function getGeoServiceApiKeys(data: Data, context: Context): IGeoServiceApiKeys {
    const locationSettings = data.getBrandProperty("Settings")?.LOCSET;

    return {
        google: locationSettings?.googleApiKey || context.getProperty("googleMapApiKey") || "",
        here: locationSettings?.hereApiKey || context.getProperty("hereMapApiKey") || "",
        mapbox: locationSettings?.mapboxApiKey || ""
    };
}
